import { Modal } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getRefBikeModelRequest } from '../../../../redux/actions/get_ref_bike_models.actions';
import { changeRefBikeLeadRequest } from '../../../../redux/actions/change_ref_bike_lead.actions';


class BikeLookupModal extends Component {
    componentDidUpdate(prevProps) {
        if (prevProps.bike_info_by_vrm?.showModal !== this.props.bike_info_by_vrm?.showModal
            && prevProps.bike_info_by_vrm?.loading !== this.props.bike_info_by_vrm?.loading
            && this.props.bike_info_by_vrm?.showModal && !this.props.bike_info_by_vrm?.loading
        ) {
            this.handleShowModal();
        }
    }

    handleShowModal = () => {
        const { lead_id } = this.props;

        if (this.props.bike_info_by_vrm.data.experian === null || this.props.bike_info_by_vrm.data.experian === undefined) {
            Modal.error({
                title: 'Error',
                content: (<p>Experian couldn't find a valid bike</p>),
                onOk: () => {
                    this.props.dispatch({
                        type: 'SET_LEAD_CREATE_DATA',
                        payload: {
                            bike_info_by_vrm: {
                                loading: false,
                                showModal: false,
                                error: null,
                                data: {},
                            },
                        },
                    });
                },
            });
        } else if (!this.props.bike_info_by_vrm.data.matchType === 'None') {
            Modal.info({
                title: 'Not found',
                content: 'Bike with provided VRM was not found',
                onOk: () => {
                    this.props.dispatch({
                        type: 'SET_LEAD_CREATE_DATA',
                        payload: {
                            bike_info_by_vrm: {
                                loading: false,
                                showModal: false,
                                error: null,
                                data: {},
                            },
                        },
                    });
                },
            });
        } else {
            Modal.confirm({
                title: 'Is this the customers motorbike?',
                width: 650,
                content: (
                    <div>
                        <div>
                            <strong>VRM: </strong>
                            <span>{this.props.bike_info_by_vrm.data.experian.vrm}</span>
                        </div>
                        <div>
                            <strong>Experian Bike Name: </strong>
                            <span>{this.props.bike_info_by_vrm.data.experian.makeModel}</span>
                        </div>
                        <div>
                            <strong>Make: </strong>
                            <span>{this.props.bike_info_by_vrm.data.experian.make}</span>
                        </div>
                        <div>
                            <strong>Model: </strong>
                            <span>{this.props.bike_info_by_vrm.data.experian.model}</span>
                        </div>
                        {(this.props.bike_info_by_vrm.data.model_variant || this.props.bike_info_by_vrm.model_variant)
                            && (
                                <div>
                                    <strong>Variant: </strong>
                                    <span>{this.props.bike_info_by_vrm.data.model_variant || this.props.bike_info_by_vrm.data.model_variant}</span>
                                </div>
                            )}
                        <div>
                            <strong>Year manufactured: </strong>
                            <span>{this.props.bike_info_by_vrm.data.experian.yearOfManufacture}</span>
                        </div>
                        <div>
                            <strong>Colour: </strong>
                            <span>{this.props.bike_info_by_vrm.data.experian.colour}</span>
                        </div>
                        <div>
                            <strong>Engine capacity: </strong>
                            <span>{this.props.bike_info_by_vrm.data.experian.engineCapacity}</span>
                        </div>
                        <div>
                            <strong>Has ABS: </strong>
                            <span>
                                {this.props.bike_info_by_vrm.data.experian.model.toLowerCase().includes('abs') ? 'YES' : 'NO'}
                                {' '}
                                (According to the Experian name)
                            </span>
                        </div>
                    </div>
                ),
                okText: 'Continue',
                cancelText: 'Not customer bike?',
                onCancel: () => {
                    this.props.dispatch({
                        type: 'SET_LEAD_CREATE_DATA',
                        payload: {
                            bike_info_by_vrm: {
                                loading: false,
                                showModal: false,
                                error: null,
                                data: {},
                            },
                        },
                    });
                },
                onOk: () => {
                    this.props.dispatch(getRefBikeModelRequest({
                        brandId: this.props.bike_details._id,
                        vrm_data: this.props.bike_info_by_vrm,
                        lead_id,
                    }));
                    this.props.dispatch(changeRefBikeLeadRequest(
                        this.props.bike_details._id,
                        'colour',
                        this.props.bike_info_by_vrm.data.experian.colour,
                        lead_id,
                    ));
                    this.props.dispatch({
                        type: 'SET_LEAD_CREATE_DATA',
                        payload: {
                            bike_info_by_vrm: {
                                loading: false,
                                showModal: false,
                                error: null,
                                data: {},
                            },
                        },
                    });
                    this.props.handleChangeEditMode();
                },
            });
        }

        return '';
    };

    render() {
        return '';
    }
}

const mapStateToProps = (state) => {
    const lead_id = state.Leads.Lead_profile.Lead_general.root_id;
    const { bike_info_by_vrm } = state.Leads.Lead_create;
    const { bike_details } = state.Leads.Lead_profile.Ref_bike_lead;

    return {
        lead_id,
        bike_info_by_vrm,
        bike_details,
    };
};

export default connect(mapStateToProps, null)(BikeLookupModal);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/components/BikeLookupModal/index.js